import React, { FC } from "react";
import { Formik, FormikProps } from "formik";
import { InputWithLabel } from "../../molecules/InputWithLabel";
import {
  Body,
  ButtonWrapper,
  Container,
  ErrorMessage,
  ForgotPassword,
  Header,
  HeaderText,
  Logo,
} from "./elements";
import logo from "../../../assets/images/new_logo_dark.svg";
import { Button } from "../../atoms/Button";
import { Loader } from "../../atoms/Loader";
import { LoginFormSchema } from "./validation";

export type LoginFormProps = {
  onForgotPassword: () => void;
  onLogin: (email: string, password: string) => Promise<void>;
  isLoading: boolean;
  innerRef?: React.Ref<FormikProps<any>>;
};

const LoginForm: FC<LoginFormProps> = (props: any) => {
  const { onForgotPassword, onLogin, isLoading, innerRef } = props;

  return (
    <Container>
      <Header>
        <Logo src={logo} alt="logo" />
        <HeaderText>Login to your account</HeaderText>
      </Header>
      <Body>
        <Formik
          innerRef={innerRef}
          onSubmit={values => onLogin(values.email, values.password)}
          initialValues={{ email: "", password: "" }}
          validateOnBlur={false}
          validateOnChange={false}
          validationSchema={LoginFormSchema}
        >
          {({ values, errors, handleChange, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <InputWithLabel
                error={!!errors.email}
                name="email"
                onChange={handleChange("email")}
                value={values.email}
                label={"Email Address"}
                type={"default"}
              />
                {errors.email && (<ErrorMessage>{errors.email}</ErrorMessage>)}
              <InputWithLabel
                error={!!errors.password}
                name="password"
                onChange={handleChange("password")}
                value={values.password}
                label={"Password"}
                type={"password"}
              />
              {errors.password && (<ErrorMessage>{errors.password}</ErrorMessage>)}
              <ForgotPassword>
                <span onClick={onForgotPassword}>Forgot Password?</span>
              </ForgotPassword>
              <ButtonWrapper>
                {isLoading ? (
                  <Loader />
                ) : (
                  <Button type="primary" htmlType="submit">
                    Login
                  </Button>
                )}
              </ButtonWrapper>
            </form>
          )}
        </Formik>
      </Body>
    </Container>
  );
};

export default LoginForm;
